import React from 'react';
import FsgoItems from './FsgoItems';
import FsgoVideosService from '../FsgoVideosService';
import { settings } from '../constants';
import {getAuthStatus} from '../../shared/utils';

class Fsgo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isDataFetched: false,
            isLoggedIn: false,
            mvpdLogoUrl: ''
        };
    }

    componentWillMount(){
        performance.mark(`fsgo[${this.props.componentId}]-componentWillMount`);
    }

    componentDidUpdate(){
        performance.mark(`fsgo[${this.props.componentId}]-componentDidUpdate`);
    }

    componentDidMount() {
        performance.mark(`fsgo[${this.props.componentId}]-componentDidMount`);
        performance.mark(`fsgo[${this.props.componentId}]-getVideos`);

        FsgoVideosService.getVideos(this.props).then(videos => {
            performance.mark(`fsgo[${this.props.componentId}]-setState`);
            this.setState(() => ({
                isDataFetched: true,
                allLiveVideosCount: videos.allLiveVideosCount,
                liveVideos: videos.liveVideos,
                featureVideos: videos.featureVideos,
                liveMatchVideos: videos.liveMatchVideos,
                featuredMatchVideos: videos.featuredMatchVideos,
                regionNames: videos.regionNames
            }))
        });

        FsgoVideosService.getAuthStatus().then(status => {
            this.setState(() => ({
                isLoggedIn: status.isLoggedIn,
                mvpdLogoUrl: status.mvpdLogoUrl
            }))
        })
        // disabling for now, will add back later
        // getAuthStatus().then(status => {
        //     this.setState(() => ({
        //         isLoggedIn: status.isLoggedIn
        //     }))
        // })
    }

    getContainerClass() {
        if (this.props.title || this.props.isFifaWC) {
            return '';
        }

        if (FsgoVideosService.isViewAllSeparatorShown(this.state.regionNames, true)) {
            return 'align-videos';
        }

        return 'align-title';
    }

    render() {
        if (!this.state.isDataFetched) return null;

        const isVideosAvailable = this.state.liveVideos.length > 0 || this.state.featureVideos.length > 0;
        const isFifaWCMatchVideosAvailable = this.props.isFifaWC && (this.state.liveMatchVideos.length > 0 || this.state.featuredMatchVideos.length > 0);
        const isFSGOShown = isVideosAvailable || isFifaWCMatchVideosAvailable;

        if (!isFSGOShown) return null;

        const isFifaWCShown = this.props.isFifaWC && isVideosAvailable;
        const isFifaWCMatchesShown = this.props.isSE && isFifaWCMatchVideosAvailable;

        return (
            <div className={this.getContainerClass()}>
                {this.props.title && !this.props.isFifaWC &&
                <div className="fsgo-title-container">
                    <h3 className="fsgo-component-title">{this.props.title}</h3>
                    <span className="separator"></span>
                </div>
                }

                <div className="fs-go-sidebar-container">
                    <ul className="tune-in-list">
                        {isFifaWCMatchesShown &&
                            <FsgoItems items={this.state.liveMatchVideos}
                                       state="live"
                                       title={'MATCHES'}
                                       isPost={this.props.postType !== settings.SF_POST_TYPE}
                                       postType={this.props.postType}
                                       isFifaWC={this.props.isFifaWC}
                                       isSE={this.props.isSE}
                                       isMatches={true}
                                       isLoggedIn={this.state.isLoggedIn}
                                       regionNames={this.state.regionNames}/>
                        }
                        {isFifaWCMatchesShown && this.state.featuredMatchVideos.length > 0 &&
                            <FsgoItems items={this.state.featuredMatchVideos}
                                       state="featured"
                                       title={''}
                                       isPost={this.props.postType !== settings.SF_POST_TYPE}
                                       postType={this.props.postType}
                                       isFifaWC={this.props.isFifaWC}
                                       isWatchReplay={true}
                                       isSE={this.props.isSE}
                                       isLoggedIn={this.state.isLoggedIn}
                                       regionNames={this.state.regionNames}/>
                        }
                        {(this.state.liveVideos.length > 0 || isFifaWCShown) &&
                            <FsgoItems items={this.state.liveVideos}
                                       state="live"
                                       title={this.props.isFifaWC ? (this.props.isSE ? 'TUNE IN' : 'TV COVERAGE'): 'LIVE NOW'}
                                       isPost={this.props.postType !== settings.SF_POST_TYPE}
                                       postType={this.props.postType}
                                       isFifaWC={this.props.isFifaWC}
                                       isFifaWCMatchesShown={isFifaWCMatchesShown}
                                       isSE={this.props.isSE}
                                       regionNames={this.state.regionNames}
                                       isLoggedIn={this.state.isLoggedIn}
                                       allCount={this.state.allLiveVideosCount}/>
                        }
                        {this.state.featureVideos.length > 0 &&
                            <FsgoItems items={this.state.featureVideos}
                                       state="featured"
                                       title={this.props.isFifaWC ? '': 'FEATURED'}
                                       isPost={this.props.postType !== settings.SF_POST_TYPE}
                                       postType={this.props.postType}
                                       isFifaWC={this.props.isFifaWC}
                                       isLoggedIn={this.state.isLoggedIn}
                                       regionNames={this.state.regionNames}/>
                        }
                    </ul>
                    {this.state.isLoggedIn && this.state.mvpdLogoUrl &&
                        <div className="channel-logo-container">
                            <img className="channel-logo-img" src={this.state.mvpdLogoUrl} />
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default Fsgo;